/* © 2022 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
export var scrollMenuItemIntoView = function scrollMenuItemIntoView(itemId) {
  var itemElem = document.querySelector('[id="' + encodeURIComponent(itemId) + '"]');
  if (itemElem) {
    var parent = itemElem.parentNode;
    var itemBottom = itemElem.offsetTop + itemElem.clientHeight;
    var visibleBottom = parent.scrollTop + parent.clientHeight;
    var distance;
    if (itemBottom > visibleBottom) {
      distance = itemBottom - (parent.clientHeight - 4);
    } else if (itemElem.offsetTop < parent.scrollTop) {
      distance = itemElem.offsetTop - 4;
    }
    distance !== undefined && parent.scrollTo({
      top: distance,
      behavior: 'smooth'
    });
  }
};